export default "/images/vendor/flag-icon-css/flags/1x1/bq.svg?1698f2886a1c568818060b89230b7ec4";